"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The PickLoginUserModel model module.
 * @module model/PickLoginUserModel
 * @version 1.1.3-alpha.1
 */
class PickLoginUserModel {
  /**
   * Constructs a new <code>PickLoginUserModel</code>.
   * Holds the email for the initial login step
   * @alias module:model/PickLoginUserModel
   */
  constructor() {
    PickLoginUserModel.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>PickLoginUserModel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PickLoginUserModel} obj Optional instance to populate.
   * @return {module:model/PickLoginUserModel} The populated <code>PickLoginUserModel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PickLoginUserModel();
      if (data.hasOwnProperty('email')) {
        obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>PickLoginUserModel</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PickLoginUserModel</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
      throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
    }
    return true;
  }
}

/**
 * User's email
 * @member {String} email
 */
PickLoginUserModel.prototype['email'] = undefined;
var _default = PickLoginUserModel;
exports.default = _default;